// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"617":"36a1ac11","703":"afd81955"}[chunkId] + ".chunk.js";
};